import { Map, Seq } from 'immutable';
import { normalize } from 'normalizr';

export function normalizeList(items, key, schema) {
  const result = normalize({ [key]: items }, { [key]: [schema] });
  return result;
}

export function mapListToRecords(js, record) {
  return Seq(js).map(record).toOrderedMap();
}

export function mapListToMaps(js) {
  return Seq(js)
    .map(obj => Map(obj))
    .toOrderedMap();
}

export function websocketsHandlerFactory(receiveAction, deleteAction, schema, key) {
  return (operation, data) => dispatch => {
    if (operation == '-') {
      if (data.id != null) {
        dispatch(deleteAction(data.id));
      } else if (data.ids != null && Array.isArray(data.ids)) {
        data.ids.forEach(id => dispatch(deleteAction(id)));
      }
    } else if (operation === '+') {
      const json = normalize(data, schema);
      receiveAction(dispatch, json);
    }
  };
}
